export default "__VITE_ASSET__B3UEI8SV__"